import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';

interface Props {
  disabled?: boolean;
}

export const PostalCodeTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <DefaultFastTextField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.generalinfo.fields.postalCode.label')}
      placeholder={t('dashboard.assets.addedit.main.generalinfo.fields.postalCode.placeholder')}
      fieldName="location.postalCode"
    />
  );
};
